import { render } from "./CompareBar.vue?vue&type=template&id=605476cc"
import script from "./CompareBar.vue?vue&type=script&lang=js"
export * from "./CompareBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__